export default __webpack_public_path__ + "static/media/times-circle-solid.bc4966d0.svg";